import { PaymentScheduleType } from '../../state/configuration/config'
import { Data } from './data'
import { Endorsement } from './endorsement'
import { InsuredAsset } from './insuredAsset'
import { InsuredProfile } from './insuredProfile'
import { AdditionalPriceOption, PriceOption } from './priceOption'

export enum QuoteStatus {
  QUOTE = 'QUOTE',
  REFERRAL = 'REFERRAL',
}

export interface Quote {
  proposalCode: string
  data: Data
  insuredAssets: InsuredAsset[]
  insuredProfiles: InsuredProfile[]
  endorsements: Endorsement[]
  promoCode?: string
  wordingVersion: string
  ratingStatus: QuoteStatus
  riskProfileId: string
  referralReasons: ReferralReason[]
  requestedOptionalCovers: Record<string, boolean>
  mainInsurer: string
  availablePaymentSchedules: PaymentOption[]
}

export interface PaymentOption {
  active: boolean
  type: PaymentScheduleType
  premiumBreakdown: PriceOption[]
  additionalPremiumBreakdown: AdditionalPriceOption[]
}

export interface ReferralReason {
  message: string
}
